
import {
    ComparePasswordDto,
    CreateUsuarioDto,
    FindOneDto,
    LoginDto,
    RemoveUsuarioDto,
    UpdateUsuarioDto,
    UsuarioResponseDto,
} from '../interfaces/user';
import { request } from './Request';

class UsersService {
    private readonly baseEndpoint = '/usuarios';

    async createUser(data: CreateUsuarioDto): Promise<UsuarioResponseDto> {
        const response = await request.post<UsuarioResponseDto>(`${this.baseEndpoint}/create`, data);
        return response.data;
    }

    async findOne(data: FindOneDto): Promise<UsuarioResponseDto> {
        const response = await request.post<UsuarioResponseDto>(`${this.baseEndpoint}/findOne`, data);
        return response.data;
    }

    async login(data: LoginDto): Promise<UsuarioResponseDto> {
        const response = await request.post<UsuarioResponseDto>(`${this.baseEndpoint}/login`, data);
        return response.data;
    }

    async updateUser(data: UpdateUsuarioDto): Promise<UsuarioResponseDto> {
        const response = await request.patch<UsuarioResponseDto>(`${this.baseEndpoint}/update`, data);
        return response.data;
    }

    async removeUser(data: RemoveUsuarioDto): Promise<UsuarioResponseDto> {
        const response = await request.delete<UsuarioResponseDto>(`${this.baseEndpoint}/remove`, data);
        return response.data;
    }

    async comparePassword(data: ComparePasswordDto): Promise<UsuarioResponseDto> {
        const response = await request.post<UsuarioResponseDto>(`${this.baseEndpoint}/compare-password`, data);
        return response.data;
    }
}

export default new UsersService();